<div *ngIf="!isPaymentLoading" class="add-payment">
  <div class="ui-g-12 p-zero dialog-header">
    <div *ngIf="!paymentId" class="send-dialog-heading">Add Payment</div>
    <div *ngIf="paymentId" class="send-dialog-heading">Edit Payment</div>

    <i class="fal fa-times fa-sm dialog-close" (click)="closePaymentModal({})"></i>
  </div>

  <div class="payment-dialog-body">
    <div style="height: 100%;" class="ui-g">
      <div style="height: 100%;" class="ui-g-12 p-zero">
        <!-- Start Left panel -->
        <div style="height: 100%;" class="ui-g-8 p-zero left-box">
          <div class="ui-g-12 p-0 mb-10px">
            <!-- Start Order AutoComplete -->
            <!-- <div class="no-estimate customer" *ngIf="isNewPayment && isOrderEditable">
              <label class="font-12 font-600 mb-4px">Order*</label>
               <app-auto-complete
                id="payment-search"
                listId="payment-search-list"
                placeholder="Search order"
                inactiveItemsKey="isArchived"
                field="title"
                theme="border"
                scrollHeight="192px"
                [suggestions]="estimateSearchResults"
                [closeOnSelection]="true"
                [hasEditableField]="false"
                [autoFocus]="isOrderEditable"
                [value]="payment?.estimate?.title"
                [isLoading]="isSearching"
                [selectInactiveItems]="false"
                (appSelect)="onEstimateSearchSelect($event)"
                (appClickOutside)="showSelected('order')"
                (appClear)="clearSearchResult('order')"
                (appCompletedMethod)="onEstimateSearch($event)"
              >
                <ng-template let-item appTemplate="item">
                  <div class="ui-g p-0" [ngClass]="{ disabled: !item?.isArchived }">
                    <div class="ui-g-12 p-0 flex-center-center">
                      <div class="ui-g-1 p-0">
                        <i class="fal fa-file-alt font-16"></i>
                      </div>

                      <div class="flex-column ui-g-11 p-0">
                        <div class="flex-between-center width-100p">
                          <span class="font-bold capitalize"> {{ item?.code }} - {{ item?.title || defaultTitle }}</span>
                          <span class="font-bold" *ngIf="item?.workFlowStatus?.name !== 'Invoice'">
                            {{ item?.workFlowStatus?.name || 'No Status' }}
                          </span>
                          <span class="font-bold" *ngIf="item?.workFlowStatus?.name === 'Invoice'">
                            {{ item?.workFlowStatus?.name || 'No Status' }} # {{ item.orderStatus === 'invoice' && item.invCode ? item.invCode : item.code }}</span
                          >
                        </div>
                        <div class="flex-between-center width-100p">
                          <span class="capitalize">{{ item?.customer?.displayName || noCustomerText }}</span>
                          <span class="">{{ item?.customer?.phone | mask: '(000) 000-0000' }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-auto-complete>

            </div> -->

            <div class="customer" [ngClass]="{ 'not-allowed': !isNewPayment, pointer: isNewPayment }">
              <label class="font-600 font-12 mb-4px">Order*</label>
              <div class="input-box">
                <div class="font-12 title-icon">
                  <div class="icon-wrapper">
                    <i class="fal fa-file-alt file-icon"></i>
                  </div>
                  <div class="font-light capitalize font-bold code-title pt-1 pl-2">
                    {{ payment?.estimate?.code }}<span *ngIf="payment?.estimate?.code"> - </span>{{
                    payment?.estimate?.title || defaultTitle }}</div>
                  <div class="font-light font-capitalize text-right workflow-status">
                    <!-- {{ payment?.workFlowStatus }} -->
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Payment Type -->
          <div class="ui-g-12 p-0 mb-10px">
            <div class="ui-g-12 p-zero">
              <p class="font-12 font-600 mb-4px float-left">Payment types*</p>
            </div>
            <div [ngClass]="{ 'payment-not-allowed': isArchived || afterPayrixPayment || afterSwipePayment }"
              class="ui-g-12 p-zero">
              <div class="payment-methods mb-2">
                <div *ngFor="let method of paymentTypes; let i = index" class="payment-method-card text-center pointer"
                  id="payment-method-{{method.label}}" (click)="!validateChangePaymentData()
                   &&
                  (!afterPayrixPayment || !afterSwipePayment) ? activateMethodCard(method, 'true') : ''" [ngClass]="{
                    'disabled not-allowed': !paymentMethodsActive[method.value] || validateChangePaymentData(),
                    'active-card': method.value === activePayment?.value,
                    'disabled not-allowed': isArchived || afterPayrixPayment || afterSwipePayment
                  }">
                  <div class="payment-method-inner">
                    <i class="font-24 {{ method.icon }}"></i>
                    <p class="font-12 font-bold mb-0">{{ method.label }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Check No -->
          <div class="ui-g-12 p-0 mb-10px" *ngIf="activePayment.value === 'cheque'">
            <label class="font-12 font-600 mb-4px">{{ dataService.checkTxt }} number*</label>
            <app-input id="payment-cheque-no" type="text" theme="border" mask="0*" placeholder="0" class="font-13"
              [hasHoverBorderBottom]="false" [disabled]="disabled" [value]="payment.checkNo" [hasHoverEffect]="false"
              (appChange)="handleChange($event, 'checkNo')">
            </app-input>
          </div>

          <!-- Amount & Date -->
          <div class="ui-g-12 p-0 mb-10px">
            <div class="ui-g-4 p-0 pr-2">
              <label class="font-12 font-600 mb-4px">Amount*</label>
              <app-input id="payment-amount" placeholder="$0.00" theme="border" [fontSize]="13"
                [selectTextOnFocus]="true" [hasHoverBorderBottom]="false"
                [allowDecimal]="focus?.collectedAmount ? true : false" [autoFocus]="focus.collectedAmount"
                [disabled]="isArchived || validateChangePaymentData()" [hasHoverEffect]="false"
                [value]="focus.collectedAmount ? payment.collectedAmount : (payment.collectedAmount | currency: usd)"
                (appChange)="handleChange($event, 'collectedAmount')" (appFocus)="handleFocus()"
                (appBlur)="validation(); checkMarkOrderAsPaid();">
              </app-input>

              <label id="payment-validation-amount" class="error-label" *ngIf="validate.amount">{{ validate.amount
                }}</label>
              <label id="payment-validation-range" class="error-label" *ngIf="validate.range">{{ validate.range
                }}</label>
            </div>

            <div class="ui-g-4 p-0 pr-2">
              <label class="font-12 font-600 mb-4px">Date</label>
              <div>
                <div
                  [ngClass]="{ 'disabled-with-default': isArchived || (!changePaymentData && isPaymentDataPrivilgesEnabled) }"
                  class="calendar-input flex-between-center payment-date pointer">
                  <p-calendar id="payment-date" placeholder="Date" styleClass="payment-pointer"
                    [(ngModel)]="payment.paymentDate"
                    [disabled]="isArchived || (!changePaymentData && isPaymentDataPrivilgesEnabled)"
                    [readonlyInput]="true" [minDate]="payment?.estimate?.createdAt" [maxDate]="maxDateRange"
                    dateFormat="M d, yy" (onSelect)="onDateTimeChange($event)" #paymentDateTimeEl></p-calendar>
                  <i class="fal fa-calendar" [ngClass]="{'d-none':isArchived}"
                    (click)="(isPaymentDataPrivilgesEnabled && changePaymentData &&
                    paymentDateTimeEl.showOverlay()) || (!isPaymentDataPrivilgesEnabled && paymentDateTimeEl.showOverlay())"></i>
                </div>
              </div>
            </div>

            <div class="ui-g-4 p-0">
              <label class="font-12 font-600 mb-4px">Time*</label>
              <div
                [ngClass]="{ 'disabled-with-default': isArchived || (isPaymentOnline && featureIsPayRixEnable && isPayrixConnected) }">
                <kendo-timepicker [(value)]="paymentTime"
                  [disabled]="isArchived || (isPaymentOnline && featureIsPayRixEnable && isPayrixConnected) || (!changePaymentData && isPaymentDataPrivilgesEnabled)"
                  [formatPlaceholder]="{ hour: 'hh', minute: 'mm' }">
                </kendo-timepicker>
              </div>
            </div>
          </div>

          <!-- calculator -->
          <app-calculate-change
            *ngIf="isCalculateChangeEnabled && payment?.collectedAmount && activePayment.value === 'cash'"
            [data]="payment"></app-calculate-change>
          <!-- calculator end -->

          <!-- Payment method -->
          <div class="payment-completed">
            <div class="ui-g-12 p-0 mb-10px">
              <div *ngIf="!isPaymentOnline || !featureIsPayRixEnable || !isPayrixConnected || paymentId"
                [ngClass]="isPaymentOnline ? 'ui-g-6 pr-0' : 'ui-g-12 p-0'">
                <label class="font-12 font-600 mb-4px">
                  <span>Payment type*</span>
                </label>

                <app-dropdown placeholder="Select" theme="border" position="top" field="name" scrollHeight="200px"
                  styleClassSelectedView="payment-method-dropdown" [id]="'payment-selection-' + activePayment.value"
                  [listId]="'payment-selection-' + activePayment.value + '-list'" [fontSize]="12"
                  [setPositionDynamically]="false"
                  [disabled]="isArchived || afterPayrixPayment || afterSwipePayment || validateChangePaymentData()"
                  [options]="paymentMethods" [isDropdownIconVisible]="true" [value]="selectedPaymentMethod"
                  (appSelect)="onCardTypeSelect($event)">
                </app-dropdown>
              </div>
              <!-- Swipe Terminals-->
              <div
                *ngIf="activePayment.value === 'card' && isPaymentOnline && isSwipeOnline && featureIsPayRixEnable && isPayrixConnected"
                [ngClass]="payment?.estimate?.workFlowStatus === 'Invoice' ? 'ui-g-12 p-0' : 'ui-g-6 pr-0'">
                <label class="font-12 font-600 mb-4px">
                  <span>Select Terminal*</span>
                </label>

                <app-dropdown placeholder="Select Terminal" theme="border" position="top" field="name"
                  scrollHeight="200px" styleClassSelectedView="payment-method-dropdown" [fontSize]="12"
                  [setPositionDynamically]="false" [disabled]="isArchived || afterPayrixPayment || afterSwipePayment"
                  [options]="terminalList" [isDropdownIconVisible]="true" [hasCustomItemTemplate]="true"
                  [value]="selectedTerminal">
                  <!-- (appSelect)="onTerminalSelect($event) Their is no method present in typescript-->
                  <ng-template let-item appTemplate="item">
                    <div class="ui-g single-terminal">
                      <div class="ui-g-12 p-0 flex-start-start">
                        <div class="w-100">
                          <p class="font-14 font-secondary-900 font-600 m-0">{{ item?.name }}</p>
                          <i class="font-12" *ngIf="!item.isTransactionPending">Available</i>
                          <i class="font-12" *ngIf="item.isTransactionPending">Unavailable
                            <span class="pl-4">#{{ item?.pendingRo }}</span>
                          </i>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </app-dropdown>
              </div>
            </div>
            <!-- Credit card no & security code -->
            <div *ngIf="
                (activePayment.value === 'card' && !isPaymentOnline) ||
                afterPayrixPayment ||
                afterSwipePayment ||
                (activePayment.value === 'card' && paymentId) ||
                (activePayment.value === 'card' && !isPayrixConnected)
              " class="ui-g-12 p-0 mb-10px">
              <div class="ui-g-6 p-0 pr-2">
                <label class="font-12 font-600 mb-4px">Last 4 digits*</label>
                <app-input type="text" mask="9999" theme="border" placeholder="" class="font-13"
                  id="payment-card-last-4" [hasHoverBorderBottom]="false"
                  [disabled]="disabled || afterPayrixPayment || afterSwipePayment" [hasHoverEffect]="false"
                  (appChange)="handleChange($event, 'card4Digits')" [value]="payment.card4Digits">
                </app-input>
              </div>
              <div class="ui-g-6 p-0">
                <label class="font-12 font-600 mb-4px">Confirmation no.*</label>
                <app-input id="payment-card-conf-no" type="text" theme="border" placeholder="" mask="0*"
                  [patterns]="confirmCardPattern" class="font-13" [hasHoverBorderBottom]="false"
                  [disabled]="disabled || afterPayrixPayment" [hasHoverEffect]="false"
                  (appChange)="handleChange($event, 'cardConfNo')" [value]="payment.cardConfNo">
                </app-input>
              </div>
            </div>
            <!-- Credit card no & security code -->
            <div hidden *ngIf="
                (activePayment.value === 'card' && !isPaymentOnline) ||
                afterPayrixPayment ||
                afterSwipePayment ||
                (activePayment.value === 'card' && paymentId) ||
                (activePayment.value === 'card' && !isPayrixConnected)
              " class="ui-g-12 p-0 mb-10px">
              <div class="ui-g-6 p-0 pr-2">
                <label class="font-12 font-600 mb-4px">Last 4 digits*</label>
                <app-input type="text" mask="9999" theme="border" placeholder="" class="font-13"
                  id="payment-card-last-4" [hasHoverBorderBottom]="false"
                  [disabled]="disabled || afterPayrixPayment || afterSwipePayment" [hasHoverEffect]="false"
                  (appChange)="handleChange($event, 'card4Digits')" [value]="payment.card4Digits">
                </app-input>
              </div>
              <div class="ui-g-6 p-0">
                <label class="font-12 font-600 mb-4px">Confirmation no.*</label>
                <app-input id="payment-card-conf-no" type="text" theme="border" placeholder="" mask="0*"
                  [patterns]="confirmCardPattern" class="font-13" [hasHoverBorderBottom]="false"
                  [disabled]="disabled || afterPayrixPayment" [hasHoverEffect]="false"
                  (appChange)="handleChange($event, 'cardConfNo')" [value]="payment?.cardConfNo">
                </app-input>
              </div>
            </div>
          </div>

          <!-- Payment method end -->

          <!-- Payment method end -->
          <!-- PayOnline -->
          <!-- Notes -->
          <div *ngIf="showNotes" class="ui-g-12 p-zero mb-10px">
            <label class="font-12 font-600 mb-4px">Notes</label>
            <div class="form-group custom-text-area font-14 mb-20 notes">
              <textarea id="payment-notes" name="notes" [disabled]="isArchived" placeholder="Notes" rows="4"
                (ngModelChange)="onChangenNote($event)" [(ngModel)]="payment.notes"></textarea>
            </div>
          </div>
        </div>

        <!-- Start Right Panel -->
        <div class="ui-g-4 p-zero right-box">
          <div class="ui-g-12 p-0 mb-2 border-bottom">
            <div class="label-row mb-1 border-bottom">
              <div class="label-heading">Total order value</div>
              <div class="label-value">
                {{ payment?.estimate?.total | currency: usd }}
              </div>
            </div>
            <div class="label-row mb-1 mt-2">
              <div class="label-heading">Paid to date</div>
              <div class="label-value">
                {{payment?.estimate?.paid || 0 | currency: usd}}
                <!-- {{ ((payment?.estimate?.card || 0) + (payment?.estimate?.cash || 0) + (payment?.estimate?.cheque || 0) + (payment?.estimate?.bank || 0) + (payment?.estimate?.creditCard || 0) + (payment?.estimate?.otherCurrentAsset || 0)) - (payment?.refundToDate || 0) || 0 | currency: usd }} -->
              </div>
            </div>
            <div class="label-row mb-1 mt-2" *ngIf="payment?.refunds && payment?.refunds?.length > 0">
              <div class="label-heading">Refund</div>
              <div class="label-value">
                {{ payment?.refundToDate || 0 | currency: usd }}
              </div>
            </div>
            <div class="label-row mb-2">
              <div class="label-heading">Payment amount</div>
              <div class="label-value" *ngIf="collectedAmmount !== 0">
                {{ focus?.collectedAmount ? payment?.collectedAmount : (payment?.collectedAmount || 0 | currency: usd)
                }}
              </div>
              <div class="label-value" *ngIf="collectedAmmount === 0">
                {{ collectedAmmount || 0 | currency: usd }}
              </div>
            </div>
          </div>

          <div class="ui-g-12 p-0 mb-2">
            <div class="label-row">
              <div class="label-heading">Remaining balance</div>

              <div class="label-value" [ngClass]="{ 'zero-balance': remainingBalance === 0 }">
                {{ remainingBalance + (payment?.refundToDate || 0) | currency: usd }}
              </div>
            </div>
          </div>

          <!-- Refund only panel-->
          <div *ngIf="payment.refunds && payment.refunds.length > 0">
            <!--  Payment History -->
            <div class="ui-g-12 p-0 border-bottom payment-history">
              <div class="label-row mb-1">
                <label class="label-heading font-13 font-600">Payment details</label>
              </div>
            </div>

            <div class="ui-g-12 p-0 mb-2">
              <div class="label-row">
                <div class="label-heading">Gross payment</div>

                <div class="label-value">
                  {{ focus.collectedAmount ? payment.collectedAmount : (payment.collectedAmount | currency: usd) }}
                </div>
              </div>
            </div>

            <div class="ui-g-12 p-0 mb-2">
              <div class="label-row">
                <div class="label-heading">Refund to date</div>

                <div class="label-value">
                  {{ payment.refundToDate || 0 | currency: usd }}
                </div>
              </div>
            </div>

            <div class="ui-g-12 p-0 mb-2">
              <div class="label-row">
                <div class="label-heading">Post refund amount</div>

                <div class="label-value">
                  {{ payment.collectedAmount - payment.refundToDate || 0 | currency: usd }}
                </div>
              </div>
            </div>
          </div>

          <!--  Payment History -->
          <div class="ui-g-12 p-0 mt-40 border-bottom payment-history" *ngIf="paymentHistory.length > 0">
            <div class="label-row mb-1">
              <label class="label-heading font-13 font-600">Payment history</label>
            </div>
          </div>

          <div *ngIf="paymentHistory.length > 0">
            <div class="ui-g-12 p-0 mt-1 payment-history" *ngFor="let pHistory of paymentHistory">
              <div class="history-row font-11" tooltipPosition="left"
                tooltipStyleClass="ticket-tooltip modifier payment-hostory-size completed" [escape]="false"
                [pTooltip]="pHistory.tooltip">
                <span class="history-heading" *ngIf="pHistory.paymentType === 'cash'">
                  Cash
                </span>

                <span class="history-heading" *ngIf="pHistory.paymentType === 'cheque'"> {{ dataService.checkTxt }} {{
                  pHistory.checkNo }} </span>

                <span class="history-heading" *ngIf="pHistory.paymentType === 'card' && featureIsPayRixEnable">
                  {{ pHistory?.isOnline ? 'Online-Card' : pHistory?.isCardSwipe ? 'Card-Swipe' : 'Card-Manual' }}, {{
                  pHistory.confirmationCode }}
                </span>

                <span class="history-heading" *ngIf="pHistory.paymentType === 'card' && !featureIsPayRixEnable"> Card {{
                  pHistory.cardType }} {{ pHistory.confirmationCode }} </span>

                <span class="history-heading" *ngIf="pHistory.paymentType === 'Refund'">
                  Refund
                </span>

                <span class="font-gray-45 float-right">
                  {{ pHistory?.amount | currency: usd }}
                </span>
              </div>

              <div class="history-payment-type">
                <span class="history-heading"> {{ pHistory?.madeBy ? 'by ' + pHistory?.madeBy : '' }} on {{
                  pHistory.createdAt | date: 'MMM d, yyyy h:mm a' }} </span>
              </div>
            </div>
          </div>
        </div>
        <!-- End Right Panel -->
      </div>
    </div>
  </div>

  <div class="ui-g-12 p-zero dialog-footer">
    <div class="ui-g-3 mark-paid p-zero">
      <app-checkbox [inputId]="'cb-mark-order-paid'" [disabled]="isArchived" label="Mark order as paid"
        [isChecked]="payment.isPaidFull" (appChange)="handleIsPaidChange($event)"> </app-checkbox>
    </div>

    <div class="ui-g-5 mark-workflo-status p-zero"></div>

    <div class="ui-g-4 p-zero text-right payment-add-footer">
      <button id="payment-btn-cancel" class="btn btn-white btn-border pointer btn-submit mr-1"
        (click)="closePaymentModal($event)">Cancel</button>
      <button id="payment-btn-save" class="btn btn-primary btn-submit" [disabled]="
          isProcessing ||
          isArchived ||
          (activePayment.value === 'card' &&
            isPaymentOnline &&
            featureIsPayRixEnable &&
            (isSwipeOnline || isPaymentOnline) &&
            isPayrixConnected &&
            !afterPayrixPayment && !afterSwipePayment && !paymentId)
        " (click)="onSubmit()">
        <span [ngClass]="{ 'pr-2': isProcessing }">Save</span>
        <i *ngIf="isProcessing" class="fal fa-spinner rotate"></i>
      </button>
    </div>
  </div>
</div>
